import React from 'react';
import bg from '../../assets/images/building.jpeg';
import logo from '../../assets/images/register-logo.png';

interface Props {
  leftContent?: React.ReactNode;
  children: React.ReactNode;
}

const AccessLayout = ({ leftContent, children }: Props) => (
  <div className="flex flex-col-reverse md:flex-row min-h-screen">
    <div
      className="hidden md:flex flex-1 justify-center items-center"
      style={{
        backgroundImage: `linear-gradient(to top, rgba(227,40,42,0.9), rgba(227,40,42,0.9)), url(${bg})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
      }}
    >
      <div className="h-full flex items-center justify-center">
        {leftContent ? leftContent : <img src={logo} alt="" />}
      </div>
    </div>
    <div className="relative flex-1 bg-white">
      <div className="flex flex-col justify-between h-full p-8">
        <div className="flex flex-col items-center justify-center flex-1 p-10">
          {children}
        </div>
      </div>
    </div>
  </div>
);

export default AccessLayout;
